import { useState } from "react";
import { getDataHightlightsStocks } from "@/controllers/data-highlights";
import { DataHighlightsStock } from "@/models/data-highlights";

export const useDataHighlights = (dataHighlights: DataHighlightsStock[]) => {
    const [fullData, setFullData] = useState<DataHighlightsStock[] | null>(null);
    const [expanded, setExpanded] = useState(false);
    const [loading, setLoading] = useState(false);

    const expand = async () => {
        if (!fullData) {
            try {
                setLoading(true);
                const result = await getDataHightlightsStocks(10);
                setFullData(result.data);
                setLoading(false);
            } catch (error) {
                console.error("Failed to fetch data highlights", error);
                setLoading(false);
            }
        }
        setExpanded(true);
    };

    const collapse = () => setExpanded(false);

    const data = expanded && fullData ? fullData : dataHighlights.slice(0, 3);

    return { data, expand, collapse, expanded, loading };
};
